import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=739e2887"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports